export default __webpack_public_path__ + "static/media/morganstanley.d60c4422.png";